import {
  FulfilmentFilterWhenType,
  NarrowFulfilmentMethodInputType,
} from '@src/graphql-types'

import { getBaseDataFromExtendedData } from '../extendData/extendFulfilmentFilterData'
import { CurriedFulfilmentFilterHookMethodArgs } from '../types'

export const setActiveFulfilmentMethods =
  ({
    currentExtendedData,
    updateFulfilmentFilter,
  }: CurriedFulfilmentFilterHookMethodArgs) =>
  (activeFulfilmentMethods: NarrowFulfilmentMethodInputType[]): void => {
    const baseData = getBaseDataFromExtendedData(currentExtendedData)

    // if only table is selected ensure when is set to ANYTIME
    if (
      activeFulfilmentMethods.length === 1 &&
      activeFulfilmentMethods[0] === NarrowFulfilmentMethodInputType.TABLE
    ) {
      baseData.when.type = FulfilmentFilterWhenType.ANYTIME
    }

    // update isActive values for each fulfilment method
    updateFulfilmentFilter({
      ...baseData,
      where: {
        ...baseData.where,
        fulfilmentMethods: activeFulfilmentMethods,
      },
    })
  }
